import _ from 'lodash';
import { useContext } from 'react';
import LoadingSpinner from 'common/components/LoadingSpinner';
import { OrderContext } from 'ui/run/RunShow/OrderStore/index';
import { getRunProfits } from 'ui/run/RunShow/OrderStore/analytics/index';
import classNames from 'classnames';
import RunSummaryChart from './RunSummaryChart';
import MetricsPanel from './MetricsPanel';

const propTypes = {};

const defaultProps = {};


const RunShowSummary = () => {
  const { isLoading, metrics, transactions } = useContext(OrderContext);

  const runProfits = !isLoading ? getRunProfits(transactions) : [];
  
  const isEmptyRunProfits = _.isEmpty(runProfits);
  const runSummaryClassName = classNames('run-summary-inner', { 'text-center': isEmptyRunProfits });

  
  return (
    <div className="run-summary">
      <div className="card">
        <div className="card-header">
          <div className="card-title">
            &nbsp;
            Run Summary
            &nbsp;
          </div>
        </div>
        <div className="card-body">
          <LoadingSpinner isLoading={isLoading}>
            <div className={runSummaryClassName}>
              <RunSummaryChart isLoading={isLoading} profits={runProfits} />
            </div>
          </LoadingSpinner>
        </div>
        <div className="card-footer bg-transparent">
          <MetricsPanel metrics={metrics} />
        </div>
      </div>
    </div>
  );
};

RunShowSummary.propTypes = propTypes;
RunShowSummary.defaultProps = defaultProps;

export default RunShowSummary;
